import { isExcludedFromAdministrationNav } from '@/config/moduleDefaults';

/** Routes registered for screen actions but omitted from sidebar / command palette menus. */
export const NAV_HIDDEN_ROUTES = new Set([
  '/hr/leave-policies',
  '/hr/documents',
  '/hr/leaves',
]);

export function isNavHiddenRoute(path: string): boolean {
  const normalized = path.split('?')[0];
  return NAV_HIDDEN_ROUTES.has(normalized) || isExcludedFromAdministrationNav(normalized);
}

export function filterHiddenNavItems<T extends { route?: string; to?: string }>(items: T[]): T[] {
  return items.filter((item) => {
    const path = (item.route ?? item.to ?? '').split('?')[0];
    return !isNavHiddenRoute(path);
  });
}
